import omit from 'lodash/omit';
import without from 'lodash/without';

import {createReducer} from '../utils/redux';

import {
    initialState as generalInitialState,
    reducers as generalReducers,
} from '../general/reducer';

import {Location, StartHour} from './actions';

const initialState = {
    ...generalInitialState,
    mapURL: null,
    showMap: false,
    position: null,
    coordinateFetchURL: null,
    locationID: 0,
    startHour: 0,
};

export default createReducer(initialState, {
    ...generalReducers,
    [StartHour.change]: (state, startHour) => ({startHour}),
    [Location.change]: (state, locationID) => ({locationID}),
    [Location.position]: (state, position) => ({position}),
    [Location.map]: (state, showMap) => ({showMap}),
    [Location.add]: ({locations}, location) => ({
        locations: {
            ...locations,
            [location.id]: location,
            favorites: location.isFavourite ? [...locations.favorites, location.id] : locations.favorites,
            history: location.isFavourite ? locations.history : [location.id, ...locations.history],
        },
    }),
    [Location.delete]: ({locations}, id) => ({
        locations: {
            ...omit(locations, id),
            favorites: without(locations.favorites, id),
            history: without(locations.history, id),
        },
    }),
    [Location.favourite]: ({locations}, {id, isFavourite}) => ({
        locations: {
            ...locations,
            [id]: {
                ...locations[id],
                isFavourite,
            },
            favorites: isFavourite ? [...locations.favorites, id] : without(locations.favorites, id),
            history: isFavourite ? without(locations.history, id) : [...locations.history, id],
        },
    }),
    [Location.edit]: ({locations}, {id, name}) => ({
        locations: {
            ...locations,
            [id]: {
                ...locations[id],
                name,
            },
        },
    }),
    [Location.move]: ({locations}, {targetIndex, destinationIndex}) => {
        const result = [...locations.favorites];
        const [removed] = result.splice(targetIndex, 1);
        result.splice(destinationIndex, 0, removed);
        return {
            locations: {
                ...locations,
                favorites: result,
            },
        };
    },
});
